// extracted by mini-css-extract-plugin
module.exports = {"storeAppointMentWrapper":"v1_storeAppointMentWrapper__u0MDb"};